"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DepositsService_defaultDepositor, _DepositsService_crossChainContracts;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositsService = void 0;
const bitcoin_1 = require("../../lib/bitcoin");
const utils_1 = require("../../lib/utils");
const deposit_1 = require("./deposit");
const crypto = __importStar(require("crypto"));
const cross_chain_1 = require("./cross-chain");
/**
 * Service exposing features related to tBTC v2 deposits.
 */
class DepositsService {
    constructor(tbtcContracts, bitcoinClient, crossChainContracts) {
        /**
         * Deposit refund locktime duration in seconds.
         * This is 9 month in seconds assuming 1 month = 30 days
         */
        this.depositRefundLocktimeDuration = 23328000;
        /**
         * Chain-specific identifier of the default depositor used for deposits
         * initiated by this service.
         */
        _DepositsService_defaultDepositor.set(this, void 0);
        /**
         * Gets cross-chain contracts for the given supported L2 chain.
         * @param _ Name of the L2 chain for which to get cross-chain contracts.
         * @returns Cross-chain contracts for the given L2 chain or
         *          undefined if not initialized.
         */
        _DepositsService_crossChainContracts.set(this, void 0);
        this.tbtcContracts = tbtcContracts;
        this.bitcoinClient = bitcoinClient;
        __classPrivateFieldSet(this, _DepositsService_crossChainContracts, crossChainContracts, "f");
    }
    /**
     * Initiates the tBTC v2 deposit process.
     * @param bitcoinRecoveryAddress P2PKH or P2WPKH Bitcoin address that can
     *                               be used for emergency recovery of the
     *                               deposited funds.
     * @param extraData Optional 32-byte extra data to be included in the
     *                  deposit script. Cannot be equal to 32 zero bytes.
     * @returns Handle to the initiated deposit process.
     * @throws Throws an error if one of the following occurs:
     *         - The default depositor is not set
     *         - There are no active wallet in the Bridge contract
     *         - The Bitcoin recovery address is not a valid P2(W)PKH
     *         - The optional extra data is set but is not 32-byte or equals
     *           to 32 zero bytes.
     */
    async initiateDeposit(bitcoinRecoveryAddress, extraData) {
        if (__classPrivateFieldGet(this, _DepositsService_defaultDepositor, "f") === undefined) {
            throw new Error("Default depositor is not set; use setDefaultDepositor first");
        }
        const receipt = await this.generateDepositReceipt(bitcoinRecoveryAddress, __classPrivateFieldGet(this, _DepositsService_defaultDepositor, "f"), extraData);
        return deposit_1.Deposit.fromReceipt(receipt, this.tbtcContracts, this.bitcoinClient);
    }
    /**
     * Initiates the tBTC v2 deposit process using a depositor proxy.
     * The depositor proxy initiates minting on behalf of the user (i.e. original
     * depositor) and receives minted TBTC. This allows the proxy to provide
     * additional services to the user, such as routing the minted TBTC tokens
     * to another protocols, in an automated way.
     * @see DepositorProxy
     * @param bitcoinRecoveryAddress P2PKH or P2WPKH Bitcoin address that can
     *                               be used for emergency recovery of the
     *                               deposited funds.
     * @param depositorProxy Depositor proxy used to initiate the deposit.
     * @param extraData Optional 32-byte extra data to be included in the
     *                  deposit script. Cannot be equal to 32 zero bytes.
     * @returns Handle to the initiated deposit process.
     * @throws Throws an error if one of the following occurs:
     *         - There are no active wallet in the Bridge contract
     *         - The Bitcoin recovery address is not a valid P2(W)PKH
     *         - The optional extra data is set but is not 32-byte or equals
     *           to 32 zero bytes.
     */
    async initiateDepositWithProxy(bitcoinRecoveryAddress, depositorProxy, extraData) {
        const receipt = await this.generateDepositReceipt(bitcoinRecoveryAddress, depositorProxy.getChainIdentifier(), extraData);
        return deposit_1.Deposit.fromReceipt(receipt, this.tbtcContracts, this.bitcoinClient, depositorProxy);
    }
    /**
     * Initiates the tBTC v2 cross-chain deposit process. A cross-chain deposit
     * is a deposit that targets an L2 chain other than the L1 chain the tBTC
     * system is deployed on. Such a deposit is initiated using a transaction
     * on the L2 chain. To make it happen, the given L2 cross-chain contracts
     * must be initialized along with a L2 signer first.
     *
     * @experimental THIS IS EXPERIMENTAL CODE THAT CAN BE CHANGED OR REMOVED
     *               IN FUTURE RELEASES. IT SHOULD BE USED ONLY FOR INTERNAL
     *               PURPOSES AND EXTERNAL APPLICATIONS SHOULD NOT DEPEND ON IT.
     *               CROSS-CHAIN SUPPORT IS NOT FULLY OPERATIONAL YET.
     *
     * @param bitcoinRecoveryAddress P2PKH or P2WPKH Bitcoin address that can
     *                               be used for emergency recovery of the
     *                               deposited funds.
     * @param l2ChainName Name of the L2 chain the deposit is targeting.
     * @returns Handle to the initiated deposit process.
     * @throws Throws an error if one of the following occurs:
     *         - There are no active wallet in the Bridge contract
     *         - The Bitcoin recovery address is not a valid P2(W)PKH
     *         - The cross-chain contracts for the given L2 chain are not
     *           initialized
     *         - The L2 deposit owner cannot be resolved. This typically
     *           happens if the L2 cross-chain contracts operate with a
     *           read-only signer whose address cannot be resolved.
     * @see {TBTC#initializeCrossChain} for cross-chain contracts initialization.
     * @dev This is actually a call to initiateDepositWithProxy with a built-in
     *      depositor proxy.
     */
    async initiateCrossChainDeposit(bitcoinRecoveryAddress, l2ChainName) {
        const crossChainContracts = __classPrivateFieldGet(this, _DepositsService_crossChainContracts, "f").call(this, l2ChainName);
        if (!crossChainContracts) {
            throw new Error(`Cross-chain contracts for ${l2ChainName} not initialized`);
        }
        const depositorProxy = new cross_chain_1.CrossChainDepositor(crossChainContracts);
        return this.initiateDepositWithProxy(bitcoinRecoveryAddress, depositorProxy, depositorProxy.extraData());
    }
    async generateDepositReceipt(bitcoinRecoveryAddress, depositor, extraData) {
        const blindingFactor = utils_1.Hex.from(crypto.randomBytes(8));
        const walletPublicKey = await this.tbtcContracts.bridge.activeWalletPublicKey();
        if (!walletPublicKey) {
            throw new Error("Could not get active wallet public key");
        }
        const walletPublicKeyHash = bitcoin_1.BitcoinHashUtils.computeHash160(walletPublicKey);
        const bitcoinNetwork = await this.bitcoinClient.getNetwork();
        const recoveryOutputScript = bitcoin_1.BitcoinAddressConverter.addressToOutputScript(bitcoinRecoveryAddress, bitcoinNetwork);
        if (!bitcoin_1.BitcoinScriptUtils.isP2PKHScript(recoveryOutputScript) &&
            !bitcoin_1.BitcoinScriptUtils.isP2WPKHScript(recoveryOutputScript)) {
            throw new Error("Bitcoin recovery address must be P2PKH or P2WPKH");
        }
        const refundPublicKeyHash = bitcoin_1.BitcoinAddressConverter.addressToPublicKeyHash(bitcoinRecoveryAddress, bitcoinNetwork);
        const currentTimestamp = Math.floor(new Date().getTime() / 1000);
        const refundLocktime = bitcoin_1.BitcoinLocktimeUtils.calculateLocktime(currentTimestamp, this.depositRefundLocktimeDuration);
        // If optional extra data is provided, check if it is valid and fail
        // fast if not.
        if (typeof extraData !== "undefined") {
            // Check if extra data vector has a correct length of 32 bytes.
            if (extraData.toString().length != 64) {
                throw new Error("Extra data is not 32-byte");
            }
            // Check if extra data vector is non-zero. This is important because a
            // deposit with defined extra data is handled via a special flow of
            // the Bridge and this vector is expected to be non-zero.
            if (extraData.toPrefixedString() ===
                "0x0000000000000000000000000000000000000000000000000000000000000000") {
                throw new Error("Extra data contains only zero bytes");
            }
        }
        return {
            depositor,
            blindingFactor,
            walletPublicKeyHash,
            refundPublicKeyHash,
            refundLocktime,
            extraData,
        };
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * Sets the default depositor used for deposits initiated by this service.
     * @param defaultDepositor Chain-specific identifier of the default depositor.
     * @dev Typically, there is no need to use this method when DepositsService
     *      is orchestrated automatically. However, there are some use cases
     *      where setting the default depositor explicitly may be useful.
     *      Make sure you know what you are doing while using this method.
     */
    setDefaultDepositor(defaultDepositor) {
        __classPrivateFieldSet(this, _DepositsService_defaultDepositor, defaultDepositor, "f");
    }
}
exports.DepositsService = DepositsService;
_DepositsService_defaultDepositor = new WeakMap(), _DepositsService_crossChainContracts = new WeakMap();
//# sourceMappingURL=deposits-service.js.map